import { Component, Inject, Input, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser'
import { ModalResponseCodes } from '../modal.service';

export interface AlertData {
    title: string,
    message: string,
    detailed: string
}

@Component({
    selector: 'fatal-modal',
    templateUrl: './fatal.html',
    styleUrls: ['../modal/modal.scss'],
    host: {
        class: 'st-fatal'
    },
    encapsulation: ViewEncapsulation.None
})
export class FatalModal {
    @Input() public title: string = "Error";
    @Input() public message: any = "Message";
    @Input() public detailed: string = "";
    @Input() public restart: string = "Restart";

    constructor(
        public dialogRef: MatDialogRef<FatalModal>,
        @Inject(MAT_DIALOG_DATA) public data: AlertData
    ) {
        this.title = data.title;
        this.message = data.message;
        this.detailed = data.detailed;
    }

    onRestartClick(): void {
        this.dialogRef.close(ModalResponseCodes.RESTART);
        window.location.reload();
    }
}



